import { Link } from "react-router-dom";
import { Trophy, ArrowRight, Mail } from "lucide-react";

export default function HolidayCamps() {
  return (
    <div data-testid="holiday-camps-page">
      <section className="relative bg-gradient-to-b from-[#0B1B3A] to-[#1E3A8A] text-white py-32 sm:py-40 overflow-hidden">
        <div className="absolute inset-0 opacity-15">
          <div className="absolute inset-0" style={{
            background: "repeating-linear-gradient(0deg, transparent, transparent 60px, rgba(255,255,255,0.05) 60px, rgba(255,255,255,0.05) 120px)"
          }} />
        </div>
        <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-md mb-6">
            <Trophy className="w-4 h-4 text-[#FBBF24]" />
            <span className="eyebrow text-white">Holiday Camps</span>
          </div>
          <h1 className="font-display heading-uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.95] text-white">
            Camps are on <span className="text-[#FBBF24]">a break.</span>
          </h1>
          <p className="mt-6 text-slate-200 text-lg leading-relaxed max-w-xl mx-auto">
            We're not running any holiday camps at the moment. Get in touch to register your interest and we'll let you know as soon as we schedule the next one.
          </p>
          <div className="mt-10 flex flex-wrap gap-3 justify-center">
            <Link to="/contact" data-testid="camps-register-interest-btn" className="btn-gold">
              <Mail className="w-4 h-4" /> Register interest
            </Link>
            <Link to="/private-sessions" data-testid="camps-see-121-btn" className="inline-flex items-center gap-2 px-8 py-4 rounded-full border-2 border-white text-white font-display font-bold uppercase tracking-[0.16em] hover:bg-white hover:text-[#1E3A8A] transition">
              Book 1-to-1 <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <div className="eyebrow text-[#1E3A8A]">Still coaching</div>
        <h2 className="font-display heading-uppercase text-3xl sm:text-4xl mt-3">1-to-1 sessions are running as normal.</h2>
        <p className="mt-4 text-slate-600 max-w-2xl mx-auto">
          Book personalised sessions with Coach Fin and Coach Louis at Bedford Terrace or Bede College in Billingham.
        </p>
        <Link to="/private-sessions" className="btn-outline-blue mt-8 inline-flex">
          See availability <ArrowRight className="w-4 h-4" />
        </Link>
      </section>
    </div>
  );
}
